import { FC } from 'react';

interface POSAGSignatureIframeProps {
  url: string;
  onError: () => void;
}
export const POSAGSignatureIframe: FC<POSAGSignatureIframeProps> = ({ url, onError }) =>
  // space for extra logic
   (
    <>
      <iframe
        src={url}
        height="542"
        width="100%"
        title="POS-AG APP"
        loading="lazy"
        onError={onError}
      />
    </>
  )
;
